import { ViewController, TextView } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class SeasonTextViewController extends ViewController {
    name: string;
    textView: TextView;

    constructor( options ) {
        options = options || {};
        options.view = options.textView || null;
        super( options );
        this.name = 'seasonTextViewController';
        this.textView = options.textView ||null;
    }

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        this.textView.setText( __('Season') + ' ' + event.season.nr );
    }
}